// TODO Duplicated enum
export enum LiveEventStatus {
  PreAir = 'PRE-AIR',
  Concluded = 'CONCLUDED',
  Interday = 'INTERDAY',
  Intermission = 'INTERMISSION',
  Live = 'LIVE'
}
